import React from 'react';

// MATERIAL-UI
import Layout from '../Layout';
import Snackbar from '@mui/material/Snackbar';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import LoginFetch from '../../fetch/LoginFetch';

const styles = {
  sectionHeader: {
    fontSize: '13px',
    color: '#666',
    fontWeight: 'bold',
  },
  sectionReminder: {
    fontSize: '13px',
    color: '#666',
    padding: '20px',
  },
  normalText: {
    fontSize: '13px',
    color: '#666',
  },
};

const button = {
  lost_username: 'Send Username',
  lost_password: 'Send Password',
  lost_up: 'Send Username/Password',
};

const message = {
  lost_username:
    'If you lost your username, please enter your E-mail Address, then click the Send Username button, and your username will be sent to your email address.',
  lost_password:
    'If you lost your password but know your username, please enter your Username and your E-mail Address, press the Send Password button, and you will receive a new password shortly. Use this new password to access the site.',
  lost_up:
    'If you forgot both your username and your password, please recover the username first, then the password. To recover your username, please enter your E-mail Address, then click the Send Username button, and your username will be sent to your email address. From there you can use this same form to recover your password.',
};

/**
 * Top level component for the Login view
 */

class ForgotPassword extends React.Component {
  getInitialState = () => {
    return {
      username: '',
      email: '',
      lost_username: false,
      lost_password: false,
    };
  };

  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.getInitialState(props), {
      forgotPasswordFailed: false,
      isFetching: false,
      forgotPasswordSnackbarMessage: '',
    });
  }

  render() {
    return (
      <Layout isFetching={this.state.isFetching}>
        <div onKeyPress={this.onKeyPress} className="col-xs-offset-1 col-xs-6">
          <br />
          <br />
          <div>
            <div style={styles.sectionHeader}>Lost your Username or your Password?</div>
            <div style={styles.sectionReminder}>
              <span style={{ fontWeight: 'bold' }}>Reminder needed for:</span>
              <FormGroup row={false}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.lost_username}
                      onChange={(event) => {
                        this.updateState({
                          lost_username: event.target.checked,
                        });
                      }}
                      value="1"
                      color="primary"
                    />
                  }
                  label="Lost Username"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.lost_password}
                      onChange={(event) => {
                        this.updateState({
                          lost_password: event.target.checked,
                        });
                      }}
                      value="1"
                      color="primary"
                    />
                  }
                  label="Lost Password"
                />
                <div style={styles.normalText}>
                  {this.state.lost_username === true && this.state.lost_password === true
                    ? message.lost_up
                    : this.state.lost_username === true
                      ? message.lost_username
                      : this.state.lost_password === true
                        ? message.lost_password
                        : ''}
                </div>
                <TextField
                  variant="standard"
                  name="username"
                  fullWidth={true}
                  onChange={this.textFieldChanged}
                  label="User name"
                  style={{
                    display:
                      this.state.lost_username === false && this.state.lost_password === true
                        ? 'inline-block'
                        : 'none',
                  }}
                />
                <TextField
                  variant="standard"
                  name="email"
                  fullWidth={true}
                  onChange={this.textFieldChanged}
                  label="E-mail Address"
                  style={{
                    display:
                      this.state.lost_username === true || this.state.lost_password === true
                        ? 'inline-block'
                        : 'none',
                  }}
                />
              </FormGroup>
            </div>
          </div>
          <br />

          {(this.state.lost_username === true || this.state.lost_password === true) && (
            <Button
              id="sendForgotPassword"
              variant="contained"
              color="primary"
              onClick={this.sendForgotPassword}
              disabled={
                this.state.lost_username === true || this.state.lost_password === true
                  ? false
                  : true
              }
              style={{ margin: '12px' }}
            >
              {this.state.lost_username === false && this.state.lost_password === true
                ? button.lost_password
                : button.lost_username}
            </Button>
          )}
        </div>
        <Snackbar
          open={this.state.forgotPasswordFailed}
          message={this.state.forgotPasswordSnackbarMessage}
          autoHideDuration={3000}
          onClose={this.handleSnackbarRequestClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        />
      </Layout>
    );
  }

  updateState = (newState) => {
    this.setState(newState);
  };

  /**
   * Function to update the local state when a TextField is update by the user
   * @param event
   * @param value
   */
  textFieldChanged = (event) => {
    const { name, value } = event.target;
    var newState = { ...this.state };
    newState[name] = value;

    this.setState(newState);
  };

  /**
   * Login to the service, and go to the main page if successful or logout if not
   */
  sendForgotPassword = () => {
    this.setState({ isFetching: true });
    LoginFetch.forgotPassword(
      this.state.lost_username,
      this.state.lost_password,
      this.state.username,
      this.state.email
    )
      .then((json) => {
        this.setState({
          forgotPasswordFailed: true,
          isFetching: false,
          forgotPasswordSnackbarMessage: json.message,
        });
      })
      .catch((ex) => {
        this.setState({
          forgotPasswordFailed: true,
          isFetching: false,
        });
      });
  };

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.sendForgotPassword();
    }
  };

  handleSnackbarRequestClose = () => {
    this.setState({ forgotPasswordFailed: false });
  };
}

export default ForgotPassword;
